@use './variables' as *;

:host {
  display: $filter-host-display;
}

.filter {
  display: $filter-display;
  font-family: $filter-font-family;
  font-size: $filter-font-size;
  font-weight: $filter-font-weight;
  line-height: $filter-line-height;
  padding-top: $filter-padding-top;
  padding-right: $filter-padding-right;
  padding-bottom: $filter-padding-bottom;
  padding-left: $filter-padding-left;
  margin-top: $filter-margin-top;
  margin-right: $filter-margin-right;
  margin-bottom: $filter-margin-bottom;
  margin-left: $filter-margin-left;

  --air-divider-margin: #{$filter-header-divider-margin};
}

.header {
  display: flex;
  justify-content: space-between;
}

.header-text {
  font-family: $filter-header-font-family;
  font-size: $filter-header-font-size;
  font-weight: $filter-header-font-weight;
  line-height: $filter-header-line-height;
}

.full-list {
  .indicator {
    transform: rotate(180deg);
  }
}

.footer {
  display: inline-flex;
}

.footer-text {
  margin-right: $filter-button-show-margin-right;
}

.link {
  text-decoration: $filter-link-text-decoration;
  color: $filter-link-color;
  cursor: pointer;

  &:hover {
    color: $filter-link-hover-color;
  }

  &:focus {
    color: $filter-link-focus-color;
  }
}
